import React from 'react';
import useInView from '../hooks/useInView';

// Fades and lifts its children in when scrolled into view.
const Reveal = ({ as: Tag = 'div', delay = 0, className = '', style, children, ...rest }) => {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? 'is-visible' : ''} ${className}`.trim()}
      style={{ '--delay': `${delay}ms`, ...style }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
